import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import './i18n'; // <-- WICHTIG: i18n Konfiguration importieren

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Wenn Sie die Messung der Web-Performance benötigen, können Sie reportWebVitals importieren und aufrufen:
// import reportWebVitals from './reportWebVitals';
// reportWebVitals();

